import { Add, FormCard, Magic } from '@lmc/ui-kit'
import { Button } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import styled from 'styled-components'
import { RotaPatternModalType } from '../RotaPattern/utils'
import colors from '@lmc/common/constants'
import { Form as AntdForm } from 'antd'
import { DefaultOptionType } from 'antd/es/cascader'
import useFeatureFlag from 'hooks/useFeatureFlags'

import { VISIT } from '../constants'
import { SkillsRequiredRowInput } from './SkillsRequiredRowInput'

type SkillOption = {
  value: string
  label: string
}

type SkillsRequiredProps = {
  skillOptions?: DefaultOptionType[]
  type?: RotaPatternModalType
  nameBasedOne?: string
  // Do not use props under probably will be driven by form
  skills?: SkillOption[]
  hasNeedsAssigned?: boolean
  onGenerateSkill?: () => void
  autoGeneratedSkills?: SkillOption[]
  maxValue?: number
}

const SkillsRequired: FC<SkillsRequiredProps> = ({
  skillOptions,
  type,
  nameBasedOne,
  maxValue,
}) => {
  const { t } = useTranslation()

  const flags = useFeatureFlag({
    flagNames: ['rostering_parked_features'],
  })?.data

  const flagRosteringParkedFeaturesEnabled =
    flags?.rostering_parked_features?.enabled

  return (
    <FormCard
      level={2}
      title={t('SKILLS_REQUIRED')}
      subtitle={t('SELECT_SKILLS')}
    >
      <AntdForm.List name="skills">
        {(fields, { add, remove }) => {
          const hasFields = !!fields?.length
          return (
            <>
              {fields.map((field, index) => (
                <SkillsRequiredRowInput
                  skillOptions={skillOptions}
                  onRemove={() => remove(index)}
                  key={field.name}
                  name={field?.name}
                  maxValue={maxValue}
                />
              ))}
              <ButtonWrapper>
                <Button
                  variant="primary"
                  onClick={() =>
                    add({
                      skillId: undefined,
                      skillSupplyNumber: 1,
                    })
                  }
                >
                  <Add />
                  {t('ADD_A_SKILL')}
                </Button>
                {type === VISIT && flagRosteringParkedFeaturesEnabled && (
                  <StyledGenerateButton
                    variant={hasFields ? 'default' : 'text'}
                    style={
                      hasFields
                        ? { border: 'none', backgroundColor: 'transparent' }
                        : {}
                    }
                    onClick={() =>
                      add({
                        skillId: skillOptions?.[0]?.value,
                        skillSupplyNumber: 1,
                      })
                    }
                    disabled={hasFields}
                  >
                    <Magic
                      color={!fields?.length ? colors?.primary : undefined}
                    />
                    {t('GENERATE_SKILLS', { variable: nameBasedOne })}
                  </StyledGenerateButton>
                )}
              </ButtonWrapper>
            </>
          )
        }}
      </AntdForm.List>
    </FormCard>
  )
}

export default SkillsRequired

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const StyledGenerateButton = styled(Button)`
  margin-left: 8px;
`
